export var CartItemType;
(function (CartItemType) {
    CartItemType[CartItemType["Traditional"] = 0] = "Traditional";
    CartItemType[CartItemType["ContinuingEducation"] = 1] = "ContinuingEducation";
})(CartItemType || (CartItemType = {}));
